import { render, staticRenderFns } from "./MonthlyInsights.vue?vue&type=template&id=4d8f2f42&scoped=true"
import script from "./MonthlyInsights.vue?vue&type=script&lang=js"
export * from "./MonthlyInsights.vue?vue&type=script&lang=js"
import style0 from "./MonthlyInsights.vue?vue&type=style&index=0&id=4d8f2f42&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d8f2f42",
  null
  
)

export default component.exports